var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MessageBoxIcons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18 0C14.4399 0 10.9598 1.05568 7.99974 3.03355C5.03966 5.01141 2.73255 7.82263 1.37018 11.1117C0.00779911 14.4008 -0.348661 18.02 0.345873 21.5116C1.04041 25.0033 2.75474 28.2106 5.27208 30.7279C7.78943 33.2453 10.9967 34.9596 14.4884 35.6541C17.98 36.3487 21.5992 35.9922 24.8883 34.6298C28.1774 33.2674 30.9886 30.9603 32.9665 28.0003C34.9443 25.0402 36 21.5601 36 18C36 13.2261 34.1036 8.64773 30.7279 5.27208C27.3523 1.89642 22.7739 0 18 0ZM25.824 15L16.716 23.496C16.3872 23.7937 15.9595 23.9585 15.516 23.9585C15.0725 23.9585 14.6448 23.7937 14.316 23.496L9.88801 19.044C9.6156 18.7173 9.47521 18.3006 9.49441 17.8757C9.51361 17.4509 9.69101 17.0485 9.99176 16.7477C10.2925 16.447 10.6949 16.2696 11.1198 16.2504C11.5446 16.2312 11.9614 16.3716 12.288 16.644L15.6 19.908L23.52 12.504C23.851 12.1953 24.2911 12.0307 24.7434 12.0465C25.1957 12.0622 25.6233 12.257 25.932 12.588C26.2407 12.919 26.4053 13.3591 26.3895 13.8114C26.3738 14.2637 26.179 14.6913 25.848 15H25.824Z",
    fill: "#008000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.a83a6722faee929903e485bb884cd775.svg";
export { ForwardRef as ReactComponent };